<fullscreen-page>
    <content-column>
        <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">

            <div class="d-flex flex-column np-header">
                <div class="p-2 h2" style="color: var(--dx-color-primary);">Preparation</div>
            </div>

            <div class="d-flex flex-column flex-fill min-vh-0">
                <div class="d-flex flex-row flex-fill gap-3 min-vh-0">
                    <div class="flex-grow-1 min-vh-0 overflow-auto tab-panel-wrap" style="flex-basis: 66.666%;">
                        <dx-tab-panel
                            [animationEnabled]="true"
                            [swipeEnabled]="false"
                            iconPosition="start"
                            stylingMode="primary"
                            width="100%">

                            <dxi-item [title]="'Kataloge in Preparation' | translate" icon="edit">
                                <div class="mt-2">
                                    <div class="catalog-list">
                                        <dx-list
                                            class="catalog-dx-list"
                                            [dataSource]="preparationCatalogs"
                                            [searchEnabled]="true"
                                            searchExpr="name"
                                            searchMode="contains"
                                            [searchEditorOptions]="searchEditorOptions"
                                            [selectionMode]="'single'"
                                            [selectedItemKeys]="selectedCatalogId ? [selectedCatalogId] : []"
                                            keyExpr="id"
                                            (onItemClick)="onCatalogRowClick($event.itemData.id)"
                                        >
                                            <div *dxTemplate="let catalog of 'item'">
                                                <div class="catalog-row catalog-row--archive"
                                                     [class.catalog-row--selected]="selectedCatalogId === catalog.id">
                                                    <div class="catalog-row__drag">
                                                        <i class="dx-icon-menu"></i>
                                                    </div>

                                                    <div class="catalog-row__main">
                                                        <div class="catalog-row__title">{{ catalog.name }}</div>
                                                    </div>

                                                    <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                                        <dx-button
                                                            icon="overflow"
                                                            stylingMode="text"
                                                            type="default"
                                                            (onClick)="openRowMenu($event, true)">
                                                        </dx-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </dx-list>
                                    </div>
                                </div>
                            </dxi-item>

                            <dxi-item [title]="'Archiv' | translate" icon="floppy">
                                <div class="mt-2">
                                    <div class="catalog-list">
                                        <dx-list
                                            class="catalog-dx-list"
                                            [dataSource]="archivCatalogs"
                                            [searchEnabled]="true"
                                            searchExpr="name"
                                            searchMode="contains"
                                            [searchEditorOptions]="searchEditorOptionsArchive"
                                            [selectionMode]="'single'"
                                            keyExpr="id"
                                            [selectedItemKeys]="selectedCatalogId ? [selectedCatalogId] : []"
                                            (onItemClick)="onCatalogRowClick($event.itemData.id)"
                                        >
                                            <div *dxTemplate="let catalog of 'item'">
                                                <div
                                                    class="catalog-row catalog-row--archive"
                                                    [class.catalog-row--selected]="selectedCatalogId === catalog.id"
                                                >
                                                    <div class="catalog-row__drag">
                                                        <i class="dx-icon-menu"></i>
                                                    </div>

                                                    <div class="catalog-row__main">
                                                        <div class="catalog-row__title">{{ catalog.name }}</div>
                                                    </div>

                                                    <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                                        <dx-button
                                                            icon="overflow"
                                                            stylingMode="text"
                                                            type="default"
                                                            (onClick)="openRowMenu($event, false)"
                                                        >
                                                        </dx-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </dx-list>
                                    </div>
                                </div>
                            </dxi-item>
                        </dx-tab-panel>
                        <dx-context-menu
                            #rowMenu
                            [dataSource]="rowMenuItems"
                            [width]="200"
                            [showEvent]="''"
                            [position]="{ my: 'left top', at: 'left bottom' }"
                            (onItemClick)="onMenuItemClick($event)">
                        </dx-context-menu>
                    </div>

                    <div class="min-vh-0 overflow-auto prepare-stage-inspector" style="flex-basis: 33.333%;">
                        <np-inspect-container-catalog
                            [container]="container"
                            [catalogId]="selectedCatalogId"
                            (containerSaved)="containerSaved.emit($event)">
                        </np-inspect-container-catalog>
                    </div>
                </div>

                <div class="mt-auto d-flex justify-content-end gap-2 p-2 border-top">
                    <dx-button
                        text="Bearbeiten"
                        icon="edit"
                        stylingMode="contained"
                        type="default"
                        (onClick)="onEditClicked()">
                    </dx-button>
                </div>

            </div>
        </div>
    </content-column>
</fullscreen-page>
